import { render, staticRenderFns } from "./EventSidebar.vue?vue&type=template&id=45129a15&scoped=true"
import script from "./EventSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventSidebar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventSidebar.vue?vue&type=style&index=0&id=45129a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45129a15",
  null
  
)

export default component.exports